<template>
    <template v-for="(item, index) in items" :key="item['path']">

        <a-menu-item
            v-if="(!item['children'] || item['children'].length === 0) && role_check(item)"
            @click="skip_url(item['path'])"
            :key="item['path']"
        >
            <component :is="item['meta']['icon']" />
            <span>{{ item['meta']['title'] }}</span>
        </a-menu-item>

        <a-sub-menu
            v-else-if="item['children'] && item['children'].length > 0 && role_check(item)"
            :key="indexPrefix ? `${indexPrefix}_${index}` : `${index}`"
        >

            <template #title>
                <component :is="item['meta']['icon']"/>
                <span>{{ item['meta']['title'] }}</span>
            </template>

            <MenuItemRecursive
                :items="item['children']"
                :indexPrefix="indexPrefix ? `${indexPrefix}_${index}` : `${index}`"
                :groupName="item['name']"
            />

        </a-sub-menu>

    </template>
</template>


<script>
export default { name: 'MenuItemRecursive' }


/**
 * Recursively search for the target path in menu items, returning the ancestor
 * submenu keys that should be expanded.
 * @param {Array} items - Menu items to search
 * @param {string} targetPath - Current route path to match
 * @param {string} prefix - Current submenu key prefix
 * @returns {Array|null} Array of open submenu keys, null if not found
 */
export function find_menu_open_keys(items, targetPath, prefix) {
    if (!items || !items.length) return null
    for (let i = 0; i < items.length; i++) {
        let item = items[i]
        let hasChildren = item['children'] && item['children'].length > 0
        let key = prefix ? `${prefix}_${i}` : `${i}`

        if (!hasChildren && item['path'] === targetPath) {
            return []
        }

        if (hasChildren) {
            let found = find_menu_open_keys(item['children'], targetPath, key)
            if (found !== null) {
                return [key].concat(found)
            }
        }
    }
    return null
}

</script>


<script setup>
import { inject, defineProps } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { compute_item_permission_key } from '@/utils/permission_utils'

const props = defineProps({
    items: { type: Array, required: true },
    indexPrefix: { type: String, default: '' },
    /** 一子级祖先路由 name，用于拼接叶子节点的权限 key */
    groupName: { type: String, default: '' }
})

const route = useRoute()
const router = useRouter()
const refresh_key = inject('refresh_key')


/**
 * Navigate to the specified URL, or force refresh if already on the same page.
 * @param {string} url - Target route path
 */
function skip_url(url) {
    if (url === route.fullPath) { refresh_key.value++ }
    else { router.push(url) }
}


/**
 * 根据路由项计算权限 key 并通过 PermissionManager 验证权限。
 * 委托给共享函数 compute_item_permission_key 实现。
 * @param {Object} item - 路由配置项
 * @returns {boolean} 是否拥有权限
 */
function role_check(item) {
    const { permission_manager } = require('@/utils/permissions')
    var permission_key = compute_item_permission_key(item, props.groupName)
    return permission_manager.valid(permission_key)
}
</script>
